'use client';

import { c as _c } from "react/compiler-runtime";
import { getGraphQLClient, getPublicSupergraphUrl } from '@cc-shopping/data-access/graphql-client';
import { useIsHydrated } from '@cc-shopping/hooks/useIsHydrated';
import { env } from '@cc-shopping/platform-env';
import { AFFECTED_FEATURES, IdentityErrorCategory } from '@cc-shopping/utils/errors/approvalOddsErrors';
import { datadogRum } from '@datadog/browser-rum';
import { useQuery } from '@tanstack/react-query';
import cookies from 'js-cookie';
import * as v from 'valibot';
import { IDENTITY_QUERY, type IdentityResponse, IdentitySchema } from '../context/identity/identityService';
const IS_DEV_ENV = env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'dev';
export const useIdentity = () => {
  const $ = _c(14);
  const isHydrated = useIsHydrated();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["identity"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = IS_DEV_ENV ? {
      retryOnMount: false
    } : {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      queryKey: t0,
      queryFn: _temp,
      ...t1,
      refetchOnMount: false,
      enabled: cookies.get("id_token") !== undefined
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data,
    isLoading,
    error,
    refetch,
    isRefetching
  } = useQuery(t2);
  const isLoggedIn = !!data?.rawIdentity?.data;
  const isNWPlusMember = !!data?.rawIdentity?.data?.identity?.is_nerdwallet_plus_member;
  const email = data?.rawIdentity?.data?.identity?.email;
  const sheaId = data?.rawIdentity?.data?.identity?.shea_id;
  const identityId = data?.rawIdentity?.data?.identity?.id;
  const identity = data?.identity;
  if (error) {
    datadogRum.addError(error, {
      message: "Error fetching identity data",
      errorCategory: IdentityErrorCategory.FETCH_ERROR,
      affectsFeatures: `${AFFECTED_FEATURES.APPROVAL_ODDS},${AFFECTED_FEATURES.CREDIT_SCORE}`
    });
  }
  const t3 = isLoading || !isHydrated;
  let t4;
  if ($[3] !== email || $[4] !== error || $[5] !== identity || $[6] !== identityId || $[7] !== isLoggedIn || $[8] !== isNWPlusMember || $[9] !== isRefetching || $[10] !== refetch || $[11] !== sheaId || $[12] !== t3) {
    t4 = {
      error,
      identity,
      identityId,
      isLoggedIn,
      isNWPlusMember,
      email,
      loading: t3,
      refetch,
      refetching: isRefetching,
      sheaId
    };
    $[3] = email;
    $[4] = error;
    $[5] = identity;
    $[6] = identityId;
    $[7] = isLoggedIn;
    $[8] = isNWPlusMember;
    $[9] = isRefetching;
    $[10] = refetch;
    $[11] = sheaId;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
async function _temp() {
  datadogRum.addAction("Identity fetch started");
  const gqlClient = getGraphQLClient({
    platform: "web",
    url: getPublicSupergraphUrl()
  });
  const response = await gqlClient.query(IDENTITY_QUERY);
  const parsedResponse = v.parse(IdentitySchema, response.data);
  return parsedResponse;
}